import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AcompanhamentoDocumentoDepr } from 'src/app/model/acompanhamento-documento-depr.model';
import { HistoricoEstado } from 'src/app/model/historico-estado.model';

@Component({
  selector: 'app-aba-historico',
  templateUrl: './aba-historico.component.html',
  styleUrls: ['./aba-historico.component.scss'],
  standalone: false,
})
export class AbaHistoricoComponent implements OnChanges {
  @Input("acompanhamentoDepr")
  public acompanhamentoDepr: AcompanhamentoDocumentoDepr;

  public historicos: HistoricoEstado[];

  ngOnChanges(changes: SimpleChanges): void {
      this.historicos = this.acompanhamentoDepr?.historicos;
  }
}
